import { mount } from 'svelte';
import App from './App.svelte';
import './styles/base.css';
import './styles/header.css';
import { initRouter } from './lib/router.svelte';
import { bootstrapIdentity, onIdentityChange } from './lib/identity.svelte';
import { resetForIdentity } from './lib/staged-edits.svelte';

initRouter();
// Wipe in-memory staged edits on identity change so a previous
// identity's draft state does not surface in a new identity's editor.
// Pairs with the identity-scoped sessionStorage key in
// staged-edits.svelte.ts.
onIdentityChange(resetForIdentity);
void bootstrapIdentity();

const appElement = document.getElementById('app');
if (!appElement) {
  throw new Error('Missing #app mount point in index.html');
}

mount(App, { target: appElement });
